// extracted by mini-css-extract-plugin
export default {"borderBox":"border-box__borderBox__UXd60"};